import type { JSX } from 'react';
import { Building2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface SidebarLogoProps {
  isCollapsed: boolean;
  headerClassName: string;
  collapseTooltip: string;
  toggleCollapse: () => void;
}

export function SidebarLogo({
  isCollapsed,
  headerClassName,
  collapseTooltip,
  toggleCollapse,
}: SidebarLogoProps): JSX.Element {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          data-testid="sidebar-logo-header"
          aria-label={collapseTooltip}
          onClick={toggleCollapse}
          className={headerClassName}
        >
          <Building2 className="h-6 w-6 text-primary shrink-0" />
          {!isCollapsed && (
            <span data-testid="sidebar-logo-text" className="text-lg font-semibold">
              Career Verification
            </span>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="right">{collapseTooltip}</TooltipContent>
    </Tooltip>
  );
}
